import * as React from 'react';

import type { ArticlesVlpEmbed } from 'bundles/unified-seo-content-common/__generated__/baseContentfulTypes';
import EntityCardDelegator from 'bundles/unified-seo-content-common/components/entity-cards/delegators/EntityCardDelegator';
import VLPVideoPlayerContainer from 'bundles/unified-seo-content-common/components/rich-text/VLPVideoPlayerContainer';
import getEntityParamsFromUrl from 'bundles/unified-seo-content-common/utils/getEntityParamsFromUrl';
import getVlpVideoParamsFromUrl from 'bundles/unified-seo-content-common/utils/getVlpVideoParamsFromUrl';

type Props = {
  embedMetadata: Pick<ArticlesVlpEmbed, 'embedType' | 'url' | 'videoDescription' | 'videoTimestamp'>;
};

const EmbedTypes = {
  entityCard: 'entity-card',
  vlpEmbed: 'vlp-embed',
} as const;

const EmbedTypeDelegator = ({ embedMetadata }: Props) => {
  switch (embedMetadata.embedType) {
    case EmbedTypes.entityCard:
      if (!embedMetadata?.url) {
        return null;
      }
      return (
        <EntityCardDelegator
          entityCardMetadata={{
            ...getEntityParamsFromUrl(embedMetadata.url),
            customDescription: embedMetadata.videoDescription,
          }}
        />
      );

    case EmbedTypes.vlpEmbed:
    default:
      if (!embedMetadata?.url) {
        return null;
      }
      return (
        <VLPVideoPlayerContainer
          {...getVlpVideoParamsFromUrl(embedMetadata.url)}
          videoDescription={embedMetadata.videoDescription}
          startAt={embedMetadata.videoTimestamp || getVlpVideoParamsFromUrl(embedMetadata.url).startAt}
        />
      );
  }
};

export default EmbedTypeDelegator;
